module.exports = "https://coursera_assets.s3.amazonaws.com/images/051d197cefacaac7c1c6917920f484ce.svg";